import { IShipmentMissingInfo } from 'types/FMSGraphqlTypes'
import { NEEDS_ATTENTION_FILTERS_MAPPER } from '../constants'
import { IMissingInfoFilters } from '../types'

export const getNeedsAttentionQueryFilters = (
  selectedFilters: IMissingInfoFilters[]
): IShipmentMissingInfo[] => {
  return selectedFilters.map(filter => NEEDS_ATTENTION_FILTERS_MAPPER[filter]).flat()
}
